import { Subject } from 'rxjs';
import { Injectable } from "@angular/core";
// @Injectable()
@Injectable()
export class KeyValue {
  // static apiBase = 'http://demo.sigmainfo.in:5000';\
  
  static apiBase = 'http://localhost:3000';
//  static animStatus = 'end'
  // Frontend Paths
  
  static allRole = 'allRole';
  static popup_size = 'small';
  static loan_popup_title = 'Save Loan Inputs';
  static security_popup_title = 'Save Securities Inputs';
  static treasury_popup_title = 'Save Treasury Inputs';
  static deposit_popup_title = 'Save Deposit Inputs';
  static studentRole = 'Student';
  static AdminRole = 'Admin';
  static decision_start_confirm = 'Are you sure you want to start the quarters?';
  static execute_simulation_confirm = 'Are you sure you want to execute the simulation?';
  static decision_confirm = 'Are you sure you want to save your inputs?';
  static navigation_decision_confirm = 'The data in the quarter form has changed. Do you want to save the changes?';
  static delete_confirm = 'Are you sure, you want to delete?';
  static delete_session_confirm = "Are you sure, you want to delete Session?"
  static email_report_confirmation_msg = "This will send the output reports (PDF/Excel) of each team's selected decisions to all members of that team. Would you like to proceed?"
  static decision_submit = "Submit for Competition";
  static submit_decision_set = "Are you sure you want to submit your action plan?"
  static submit_decision_set_note = "Note: You may not edit your action plan for this quarter after clicking Submit.";
  static community_renamed = "Community renamed.";
  static decision_form_error = 'Correct errors on form and resave.';
  static decision_set_error_while_saving = 'Error occured while Creating/Updating Quarters Set.';
  static remove_user_confirm = "Do you wish to remove the user";
  static InstructorRole = 'Instructor';
  static select_student = 'Please select a member to reset the password.';
  static reset_only_student = 'Password can be reset only for students.';
  static InstructorAdminRole = 'InstructorAdmin';
  static page_save_error = 'Please correct the error on the page and resubmit.';
  static error_popup_title = 'Page Error';
  static repos_val = 'The selected Bills and Bonds impact Treasury Repos.';
  static connectivity_error_message = 'Please check your internet connection and try again.';
  static server_error_message = 'Error connecting to server please try again.';
  static api_error_message = 'There is an error with API.'
  static server_unauthorized  = 'Your Session has expired. Please login again.';
  static signinPath = '/sign-in';
  static allPath = '/';
  static studentPath = '/student';
  static studentHomePath = '/student/home';
  static selectSecurityDecisions = '/control/security-decisions';
  static loanDecisions = '/control/loan-decisions';
  static depositsDecisions = '/control/deposits-decisions';
  static treasuryDecisions = '/control/treasury-decision';
  static adminPath = '/admin';
  static sessionControlPath = '/control';
  static adminNewPath = '/admin/new';
  static adminViewSummaryPath = '/admin/view-summary';
  static adminAddNewEconomyPath = '/admin/manage-economy';
  static adminHomeFindUserPath = '/admin/find-user'
  static instructorPath = '/instructor';
  static instructorAdminPath = '/instructor-admin';
  static licencePath = '/licence-terms';
  static changePasswordPath = '/change-password';
  static changePasswordPathSubmit = '/change-password-submit';
  static modifyCommunityPath = '/control/modify_community';
  static modifyTeamPath = '/control/modify_teams';
  static simulationStatusPath = '/control/simulation-status'
  static decisionStatusPath = '/control/decision-status'
  static submiteddecisionStatusPath = '/v1/decision_status/:id/check_submited_decisions'
  static printDecisionPath = '/control/print-decision-forms'
  static whatifsimulation = '/control/what-if-simulation'
  static addloanpath = '/control/add-loan';
  static changeControlPath = '/control/work-session';
  static insControlsPath = '/control/instructor-controls';
  

  static changeLoansPath = '/control/loans';
  static decisionstatusPath = '/v1/decision_status';
  static get_decision_set = '/v1/decision_status/:id/get_decision_set';
  static changeTreasuryPath = '/control/treasury';
  static securitiesPath = '/control/securities';
  static depositsPath = '/control/deposits';
  static selecteconomyPath = '/control/select-economy';
  static modifyStartPath = '/control/modify_start_position';
  static modifySessionpParameter = '/control/modify-session';
  static selectInstructorReports ='/control/instructor-report';
  static selectStartQuarterReports ='/control/start-quarter-report';
  static selectBankReports ='/control/bank-report';
  static selectWhatIfReports ='/control/what-if-report';
  static selectDecisionForms ='/control/select-decision';
  static workSessionPath = '/control/work-session';
  static statisticsPath = '/control/statistics';
  static sessionstatisticsPath = '/control/session-statistics';
  static viewstatisticsPath = '/control/view-statistics';
  static userTemplateDownloadPath = 'https://content.aba.com/BankExec/Files/bx_user_template.xls';
  static interfacePath = 'https://content.aba.com/BankExec/Files/BXD_Online_Interface.pdf';
  static interfaceManualPath = '/manual/admin-manual.html';
  static interfaceManualPdfPath = 'https://content.aba.com/BankExec/Files/BX2AdminManual_FINAL.pdf';
  static decisionManualPath = '/manual/decision-manual.html';
  static decisionManualPdfPath = 'https://content.aba.com/BankExec/Files/BX2DecisionManual_FINAL.pdf';
  static gettingStartedPath = 'https://content.aba.com/BankExec/Files/BXD_Online_Interface.pdf';
  static demoLink = 'https://content.aba.com/bankexec/quicktour/briefing/index.html';
  static supportPath = '/support';
  static popuplinkPath = '/links';
  static addEconomyPath = '/manage-economy';
  static adminFindUserPath = '/find-user';
  static instructorAdminFindUserPath = '/instructor-admin/find-user';

  // backend
  static api_onboard= '/v1/home/onboard';
  static api_decisionStatusUpdate = '/v1/decisions/status_update';
  static api_agree_terms= '/v1/home/agree_terms';
  static api_change_password= '/v1/home/change_password';
  static set_current_session = '/v1/home/set_current_session';
  static api_after_password_recovery = '/v1/home/:id/after_password_recovery';
  static api_sessions_index = '/v1/work_sessions';
  static api_statistics_index = '/v1/statistics';
  static api_decision_forms_index = '/v1/decision_forms';
  static api_sessions_create = '/v1/work_sessions';
  static api_startDecisionPath = '/v1/decisions/start_decisions';
  static api_get_work_sessions = '/v1/work_sessions';
  static api_sessions_update = '/v1/work_sessions/update';
  static api_sessions_destroy = '/v1/work_sessions/';
  static api_modify_session_destroy = '/v1/contact_sessions/';
  static api_economy_index = '/v1/economy_dds';
  static api_instructor_report_dd_index = '/v1/instructor_report_dds';
  static api_bank_report_dd_index = '/v1/bank_report_dds';
  static api_instructor_report_update = '/v1/instructor_reports/:id/update_instructorreports';
  static api_start_quarter_report_update = '/v1/start_quarter_reports/:id/selectionUpdate';
  static api_bank_report_update = '/v1/bank_reports/:id/update_bankreports';
  static api_loan_product_update = '/v1/loan_products/:id/update_loan_products';
  static api_decision_forms_update = '/v1/decision_forms/:id/update_decision_forms';
  static api_instructor_report_index = '/v1/instructor_reports';
  static api_start_quarter_report_index = '/v1/start_quarter_reports';
  static api_bank_report_index = '/v1/bank_reports';
  static api_loan_product_index = '/v1/loan_products';
  static api_modify_session_index = '/v1/contact_sessions';
  static api_modify_session_update = '/v1/contact_sessions/:id/update_contactsessions';
  static api_roll_back_decision = '/v1/decisions/:id/rollback_decision';
  static api_economy_create = '/v1/economy_dds';
  static api_economy_pdf = '/v1/economy_dds/economy_pdf';
  static api_startposition_create = '/v1/start_positions';
  static api_startposition_update = '/v1/start_positions/';
  static api_execute_start_quarter = '/v1/start_positions/:id/execute_start_quarter';
  static api_startposition_index = '/v1/start_positions';
  static api_selected_economy = '/v1/start_positions/:id/view_selected_economy';
  static api_save_start_position = '/v1/start_positions/:id/save_start_position';
  static api_get_start_position_status = '/v1/start_positions/:id/get_start_position_status';
  static api_loans_index = '/v1/loans';
  static api_decision_loans_index = '/v1/loans/:id/decision_status_loans';
  static api_treasury_index = '/v1/treasuries';
  static api_getworksessionsummary = '/v1/work_sessions/:id/getworksessionsummary';
  static licence_rejected_msg = 'Must Confirm License Agreement.';
  static api_getCommuities = '/v1/communities/';
  static api_add_economy = '/v1/add_economy';
  static api_economy_destroy = '/v1/add_economy/delete_economy';
  static api_communities_create = '/v1/communities';
  static api_communities_update = '/v1/communities/:id/update_communities';
  static api_getTeams = '/v1/teams';
  static api_loan_update = '/v1/loans/:id/update_loans';
  static api_treasury_update = '/v1/treasuries/:id/update_treasuries';
  static api_community_destroy = '/v1/communities/';
  static api_securitiesPath = '/v1/securities';
  static api_decision_securitiesPath = '/v1/securities/:id/decision_status_securities';
  static api_decision_treasuryPath = '/v1/treasuries/:id/decision_status_treasuries';
  static api_student_securitiesPath = '/v1/securities/:id/student_security_create';
  static api_depositsPath = '/v1/deposits';
  static api_decision_depositsPath = '/v1/deposits/:id/decision_status_deposits';
  static api_addUserToTeam = '/v1/teams';
  static api_removeMember = '/v1/teams/:id/remove_member';
  static api_addBulkUser = '/v1/teams/:id/create_bulk_users';
  static api_decisionsPath = '/v1/decisions';
  static api_updateTimezonePath = '/v1/decisions/:id/update_time_zone';
  static api_updatePresession = '/v1/decisions/:id/update_presession';
  static api_getPresession = '/v1/decisions/:id/fetch_presession'
  static api_simulation_status = '/v1/simulations';
  static api_update_team = '/v1/simulations/:id/update_team';
  static api_update_decision_set = '/v1/simulations/:id/update_decision_set';
  static api_active_member = '/v1/simulations/:id/update_active';
  static api_update_start_position = '/v1/start_positions/:id/update_start_position';
  static api_active_students = '/v1/simulations/:id/update_students';
  static api_email_students = '/v1/simulations/:id/email_students';
  static api_email_member = '/v1/simulations/:id/email_member';
  static api_email_communityReports = '/v1/simulations/:id/email_community_reports'
  static api_email_team = '/v1/simulations/:id/email_team';
  static api_play = '/v1/simulations/:id/play';
  static api_update_team_name = '/v1/decision_status/:id/update_team';
  static api_update_approved = '/v1/decision_status/:id/update_approved';
  static api_current_decision_set = '/v1/decision_status/:id/current_decision_set';
  static api_set_team = '/v1/decision_status/:id/set_team';
  static api_getSimulationReports = '/v1/simulation_bank_reports'
  static api_reportsPath = '/v1/reports';
  static api_broadcast_email = '/v1/teams/broadcast_email'
  static api_reset_password = '/v1/teams/:id/reset_password'
  static api_reset_password_using_token = '/v1/teams/:id/reset_password_using_token'; // API to reset password using token
  static api_playWhatIfSimulation = '/v1/what_if_simulations/play';
  static api_WhatIfSimulation = '/v1/what_if_simulations';
  static api_views = '/v1/work_sessions/:id/reset_call';
  static api_reset_quarter = '/v1/work_sessions/:id/reset_for_quarter';
  static api_rollforward = '/v1/work_sessions/:id/roll_forward';
  static api_handle_forward = '/v1/work_sessions/:id/handle_forward';
  static api_is_reset = '/v1/work_sessions/:id/query_reset';
  static api_get_work_session_for_student = '/v1/home/:id/work_session_for_student';
  static api_get_session_status = '/v1/work_sessions/:id/get_session_status';
  static api_upload_attachment = '/v1/simulations/:id/upload_attachment';
  static api_editor_attachment = '/v1/simulations/:id/editor_attachment';
  static api_delete_attachment = '/v1/simulations/:id/delete_attachment';
  static api_delete_old_attachment = '/v1/simulations/:id/delete_old_attachment';
  static api_rollback_decision_executed = '/v1/simulations/:id/rollback_decision_executed';
  static api_users = '/v1/users';
  static api_delete_user = '/v1/users/';
  static api_fetch_agreement='/v1/users/fetch_agreement';
  static api_fetch_user_from_token='/v1/users/fetch_user_from_token'; // API to fetch user details from token
  static api_update_login_notification = '/v1/notifications';
  static api_client_ping = '/v1/tokens/ping'; // API to ping the token for validating login

  //setter for updating current session to localstorage
  setCurrentSession(work_session){
    localStorage.setItem('CurrentSession',JSON.stringify(work_session));
  }
  //getter for getting current session from localstorage
  getCurrentSession(){
    return JSON.parse(localStorage.getItem('CurrentSession'));
  }

  // converts float to integer
  parse_value(val) {
    if (val != null) {
      const final_value = Math.round(val);
      return isNaN(final_value) ? '' : final_value
    }else {
      return '';
    }
  }

  // rounds decimal value to two digits
  round_value(r,val) {
    return (val === null || val === '') ? '' : val === -98765.0 ? 'N/A' : val.toFixed(r);
  }

  treasury_round_value(r,val) {
    const final_value = val === null ? '' : val === -98765.0 ? 'N/A' : val.toFixed(r);
    if (final_value === '0.0') {
      return 0;
    }else {
      return final_value;
    }
  }
  // source Subjects
  public all_worksessions: Subject<any> = new Subject<any>();
  public list_worksessions: Subject<any> = new Subject<any>();
  public current_session: Subject<any> = new Subject<any>();
  public teamList: Subject<any> = new Subject<any>();
  public hidePresessionButton: Subject<any> = new Subject<any>();
  public communityTeams: Subject<any> = new Subject<any>();
  public instructorAdmins: Subject<any> = new Subject<any>();
  public all_decisions: Subject<any> = new Subject<any>();
  public helpUrl: Subject<any> = new Subject<any>();


  public rollback_decisions: Subject<any> = new Subject<any>();
  public work_flow_view: Subject<any> = new Subject<any>();
  public start_report: Subject<any> = new Subject<any>();
  public decision_sets: Subject<any> = new Subject<any>();
  public decision_sets_is_submit: Subject<any> = new Subject<any>();
  public current_decision_set: Subject<any> = new Subject<any>();
  static animStatus: Subject<string> = new Subject<string>();
  static flash_msg: Subject<any> = new Subject<any>();
  public simulation_status: Subject<any> = new Subject<any>();
  public simulation_status_data: Subject<any> = new Subject<any>();
  static report_menu: Subject<any> = new Subject<any>();
  static help_id: Subject<any> = new Subject<any>();
  public quarter_list: Subject<any> = new Subject<any>();
  public load_decision_forms: Subject<any> = new Subject<any>();
  public currentSessionUpdated: Subject<any> = new Subject<any>();
  public presessionUpdated: Subject<any> = new Subject<any>();
  public presentationStateReached: Subject<any> = new Subject<any>();
  public studentTimeLeft: Subject<any> = new Subject<any>();

  // Observable streams
  all_worksessions$ = this.all_worksessions.asObservable();
  all_decisions$ = this.all_decisions.asObservable();
  helpUrl$ = this.helpUrl.asObservable();
  
  rollback_decisions$ = this.rollback_decisions.asObservable();
  work_flow_view$ = this.work_flow_view.asObservable();
  list_worksessions$ = this.list_worksessions.asObservable();
  current_session$ = this.current_session.asObservable();
  teamList$ = this.teamList.asObservable();
  hide_presession_button$ = this.hidePresessionButton.asObservable();
  communityTeams$ = this.communityTeams.asObservable();
  instructorAdmins$ = this.instructorAdmins.asObservable();
  start_report$ = this.start_report.asObservable();
  decision_sets$ = this.decision_sets.asObservable();
  decision_sets_is_submit$ = this.decision_sets_is_submit.asObservable();
  current_decision_set$ = this.current_decision_set.asObservable();
  animStatus$ = KeyValue.animStatus.asObservable();
  flash_msg$ = KeyValue.flash_msg.asObservable();
  simulation_status$ = this.simulation_status.asObservable();
  simulation_status_data$ = this.simulation_status_data.asObservable();
  report_menu$ = KeyValue.report_menu.asObservable();
  help_id$ = KeyValue.help_id.asObservable();
  quarter_list$ = this.quarter_list.asObservable();
  load_decision_forms$ = this.load_decision_forms.asObservable();
  currentSessionUpdated$ = this.currentSessionUpdated.asObservable();
  presessionUpdated$ = this.presessionUpdated.asObservable();
  presentationStateReached$ = this.presentationStateReached.asObservable();
  studentTimeLeft$ = this.studentTimeLeft.asObservable();

  // Service Methods

  // observable to update report menus based on session
  static update_report_menu(msg: any){
    console.log('update report menu called.....');
    this.report_menu.next(msg);
  }

  static get_help_id(msg: any){
    this.help_id.next(msg);
  }

  all_worksessions_update(msg: any) {
    this.all_worksessions.next(msg);
  }

  simulation_status_update(msg: any) {
    this.simulation_status.next(msg);
    localStorage.setItem('simulation_status',msg);
  }

  list_worksessions_update(msg: any) {
    this.list_worksessions.next(msg);
  }

  update_teamList(msg: any){
    this.teamList.next(msg);
  }

  hide_presession_button(msg: any){
    this.hidePresessionButton.next(msg);
  }

  update_communityTeams(msg: any){
    this.communityTeams.next(msg);
  }
  update_instructorAdmins(msg: any){
    this.instructorAdmins.next(msg);
  }

  current_session_update(msg: any) {
    this.current_session.next(msg);
  }

  current_decisions_update(msg: any) {
    this.all_decisions.next(msg);
  }

  update_helpUrl(msg: any){
    this.helpUrl.next(msg);
  }

  current_rollback_decisions_update(msg: any) {
    this.rollback_decisions.next(msg);
  }
  workflow_update(msg: any) {
    this.work_flow_view.next(msg);
  }
  decision_sets_update(msg: any) {
    this.decision_sets.next(msg);
  }

  start_report_action(msg: any) {
    this.start_report.next(msg);
  }

  decision_sets_is_submited_update(msg: any) {
    this.decision_sets_is_submit.next(msg);
  }

  current_decision_set_update(msg: any) {
    this.current_decision_set.next(msg);
  }

  static animStatus_update(msg: string) {
    this.animStatus.next(msg);
  }

  simulation_status_data_update(msg: any) {
    this.simulation_status_data.next(msg);
  }

  quarter_list_update(msg: any) {
    this.quarter_list.next(msg);
  }

  static  startAnim(): void {
      // console.log('animation started ..... ');
      document.getElementById('loader1').style.display = 'block'
  }

  static endAnim(): void {
      // console.log('animation ended ..... ');
      document.getElementById('loader1').style.display = 'none'
  }

  static flash_msg_update(msg: any) {
    this.flash_msg.next(msg);
  }

  form_load_update(msg: any) {
    this.load_decision_forms.next(msg);
  }

  currentSessionUpdatedOnServer(){
    this.currentSessionUpdated.next();
  }

  presessionUpdatedOnServer(msg: any) {
    this.presessionUpdated.next(msg);
  }

  presentationStateReachedUpdate(msg: boolean){
    this.presentationStateReached.next(msg);
  }

  // observable to update student time left
  update_student_time_left(msg: any) {
    this.studentTimeLeft.next(msg);
  }

}
